import React, { useState } from "react";
import GetAppIcon from "@mui/icons-material/GetApp";
import { IconButton, TableCell, TableRow } from "@mui/material";
import FileStatus from "./fileStatus/fileStatus";
import { ImportQuoteFileHistoryResponse } from "@/main/models/response";
import { downloadFile } from "@/main/services/utilsFile";
import { getTranslateByKey, isNullUndefined } from "@/main/services/utils";
import { quoteImportApi } from "@/main/api";
import { SpinnerLoading } from "@/main/components/shared/styles";
import * as S from "./styles";

interface IFileHistoryRow {
	file: ImportQuoteFileHistoryResponse;
}

function FileHistoryRow({ file }: IFileHistoryRow) {
	const fileName = `${file.fileName}.${file.fileExtension.toLowerCase()}`;
	const [isLoadingDownloadFile, setIsLoadingDownloadFile] = useState<boolean>(false);
	const [isLoadingDownloadFileError, setIsLoadingDownloadFileError] = useState<boolean>(false);

	async function onDownloadFile() {
		try {
			setIsLoadingDownloadFile(true);
			const responseApi = await quoteImportApi.downloadFileImportHistory(file.guid);

			if (responseApi.data.result) {
				const base64File = responseApi.data.result;
				downloadFile(base64File, fileName);
			}
		} catch {
		} finally {
			setIsLoadingDownloadFile(false);
		}
	}

	function handleClickDownloadFile(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
		e.preventDefault();
		e.stopPropagation();

		onDownloadFile();
	}
	function handleClickDownloadErrorFile() {
		setIsLoadingDownloadFileError(true);
		quoteImportApi
			.downloadErrorFileImportHistory(file.guid)
			.then((response) => {
				if (response.data.result) {
					const base64File = response.data.result;
					const fileNameError = `${file.fileName}-error.json`;
					downloadFile(base64File, fileNameError);
				}
			})
			.finally(() => {
				setIsLoadingDownloadFileError(false);
			});
	}

	const translateMessage = getTranslateByKey(file.quoteImportStatus.split("t.nah.")[1]);
	const errorMessage = !isNullUndefined(file.errorMessage) ? `- ${file.errorMessage}` : "";
	const messageTooltip = `${translateMessage} ${errorMessage}`;

	return (
		<TableRow>
			<TableCell>
				<S.FileNameArea title={fileName}>
					<S.FileNameText>{file.fileName}</S.FileNameText>
					<span>.{file.fileExtension.toLowerCase()}</span>
				</S.FileNameArea>
			</TableCell>
			<TableCell>
				<S.AreaButtons>
					<IconButton
						id="id-importQuote-btn-downloadFile"
						onClick={handleClickDownloadFile}
						disabled={isLoadingDownloadFile}
					>
						{isLoadingDownloadFile ? <SpinnerLoading size="xsmall" /> : <GetAppIcon />}
					</IconButton>
					{isLoadingDownloadFileError ? (
						<SpinnerLoading size="xsmall" noMargin />
					) : (
						<FileStatus
							idFileStatus={Number(file.idQuoteImportStatus)}
							title={messageTooltip}
							messageTooltip={file.errorMessage}
							onCustomClick={() => handleClickDownloadErrorFile()}
						/>
					)}
				</S.AreaButtons>
			</TableCell>
		</TableRow>
	);
}

export default FileHistoryRow;
